import {XMarkIcon} from "@heroicons/react/24/solid";
import React, {useState} from "react";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";

const ProductBlogPostStatistics = ({statistics}) => {

    return (
        <>
            <div className={'p-4 border border-gray-400 bg-white rounded-xl'}>

                <div className={'text-lg text-pink-500 font-semibold mb-2'}>
                    Statistics
                </div>

                <div className="flex flex-wrap justify-center items-center">
                    <div className={'m-2 p-2 items-center text-center bg-sky-100 border border-sky-200 rounded w-32'}>
                        <div className={'font-semibold'}>{statistics?.words || 0}</div>
                        <div>Words</div>
                    </div>
                    <div className={'m-2 p-2 items-center text-center bg-sky-100 border border-sky-200 rounded w-32'}>
                        <div className={'font-semibold'}>{statistics?.characters || 0}</div>
                        <div>Characters</div>
                    </div>
                    <div className={'m-2 p-2 items-center text-center bg-sky-100 border border-sky-200 rounded w-32'}>
                        <div className={'font-semibold'}>{statistics?.totalSections || 0}</div>
                        <div>Sections</div>
                    </div>
                    <div className={'m-2 p-2 items-center text-center bg-sky-100 border border-sky-200 rounded w-32'}>
                        <div className={'font-semibold'}>{statistics?.totalParagraphs || 0}</div>
                        <div>Paragraphs</div>
                    </div>
                    <div className={'m-2 p-2 items-center text-center bg-sky-100 border border-sky-200 rounded w-32'}>
                        <div className={'font-semibold'}>{statistics?.totalLinks || 0}</div>
                        <div>Links</div>
                    </div>
                    <div className={'m-2 p-2 items-center text-center bg-sky-100 border border-sky-200 rounded w-32'}>
                        <div
                            className={'font-semibold'}>{statistics?.totalImages || 0} / {statistics?.requiredImagesCount || 0}</div>
                        <div>Images</div>
                    </div>
                </div>

                {/*{instructionList?.map((instruction, instructionIndex) => (
                    <div key={`instruction-${instructionIndex}`}>
                        <div className={'flex items-center justify-between'}>
                            <div className={`flex justify-start text-gray-900}`}>
                                <div className={''}>{instructionIndex + 1}.</div>
                                <div className={'ml-2'}>{instruction.text}</div>
                            </div>
                        </div>
                    </div>
                ))}*/}
            </div>
        </>
    )
}

export default ProductBlogPostStatistics
